/**
 * Phase 3 - Greek translations module
 */
import enBase from './en.js';
import { translationsEl } from '../../utils/translations/translations.el.js';
import { plansTranslationsEl } from '../../utils/translations/plans/plansTranslations.el.js';

const merged = { ...enBase, ...translationsEl, ...plansTranslationsEl };
export default merged;
